import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgAccessible(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "accessible_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#accessible_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, {
      children: [_jsx("path", {
        d: "M34.272 28.979l3.16-3.068c.347-.389.771-.704 1.248-.926a3.935 3.935 0 014.382.733c.373.364.665.799.858 1.277a3.643 3.643 0 01-.118 2.985c-.23.463-.554.875-.955 1.21l-3.156 3.078",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M39.692 34.268l3.156-3.068c.346-.385.77-.697 1.245-.917a3.935 3.935 0 014.365.73c.373.362.665.794.859 1.27a3.643 3.643 0 01-.098 2.973 3.75 3.75 0 01-.94 1.213l-3.157 3.073",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M45.122 39.542l3.156-3.073c.349-.38.774-.687 1.249-.902a3.94 3.94 0 014.345.747c.37.36.662.79.855 1.264a3.649 3.649 0 01-.086 2.96 3.753 3.753 0 01-.928 1.215L39.78 54.18l-3.788 3.223c-1.42.92-2.042 1.362-3.262 1.853a10.3 10.3 0 01-7.696 0C24 58.84 22 58 20 56l-2-2c-3.401-3.301-5.212-11.33-5.212-11.33L9.086 25.277a3.721 3.721 0 01-.02-1.492c.094-.494.288-.965.57-1.387a3.878 3.878 0 011.072-1.069 3.995 3.995 0 011.41-.588 4.046 4.046 0 011.537.045c.504.113.98.322 1.401.614.421.292.779.662 1.053 1.088.273.427.458.902.543 1.398l1.847 9.863 21.732-21.127c.355-.365.78-.66 1.252-.865a4.03 4.03 0 014.312.71A3.773 3.773 0 0146.88 15.2a3.783 3.783 0 01-1.22 2.68L34.272 28.978",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M23.657 4v7.605M13.229 8.417l4.517 4.392M33.936 8.417l-4.517 4.392",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgAccessible;